import React, { useContext, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { compose } from "recompose";

import "./../css/styles.css";
import "./../App.css";
import "./../css/QuotationTheme.css";

import Formularios from "./../pages/Formularios";
import Landing from "../pages/Landing/Landing";
import Footer from "./../components/Footer/Footer";
import WhatsAppFab from "./../components/WhatsAppFAB";

import ClienteDirectoContext, {
    withClienteDirectoContextProvider,
    withClienteDirectoContextReady,
} from "./../context/ClienteDirectoContext";
import {withCotizarContextProvider, withCotizarContextReady} from "../context/CotizarContext/withCotizarContext";
import { getThemeClassByTemplateId } from "../constants/polkistaThemes";

const FormulariosWithContext = compose(
    withCotizarContextProvider,
    withCotizarContextReady
)(Formularios);

function PolkistasRoutesBase() {
    const { templateId } = useContext(ClienteDirectoContext);

    const themeClass = useMemo(
        () => getThemeClassByTemplateId(templateId),
        [templateId]
    );

    return (
        <div className={`polko-theme ${themeClass} general`}>
            <div className="main">
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/cotizar/:producto" element={<FormulariosWithContext />} />
                </Routes>
            </div>
            <Footer />
            <WhatsAppFab />
        </div>
    );
}

export default compose(
    withClienteDirectoContextProvider,
    withClienteDirectoContextReady,
)(PolkistasRoutesBase);
